<div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 rounded-md mb-4 p-4">

  <div *ngIf="contexto?.anoLetivo" class="flex items-center justify-between py-1 mb-2 last:mb-0">
    <span class="text-sm font-semibold text-gray-600 dark:text-gray-400">Ano Letivo:</span>
    <span class="text-sm text-gray-900 dark:text-gray-100 text-right max-w-[60%]">{{ contexto?.anoLetivo?.ano }}</span>
  </div>

  <div *ngIf="contexto?.turma" class="flex items-center justify-between py-1 mb-2 last:mb-0">
    <span class="text-sm font-semibold text-gray-600 dark:text-gray-400">Turma:</span>
    <span class="text-sm text-gray-900 dark:text-gray-100 text-right max-w-[60%]">{{ contexto?.turma?.descricao }}</span>
  </div>

  <div *ngIf="!contexto || (!contexto.turma && !contexto.anoLetivo)" class="flex items-center py-1">
    <span class="text-sm text-red-600 dark:text-red-400">Carregando contexto...</span>
  </div>

</div>
